import React, { FC, ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import {
  resetBillingCheckBox,
  setAllContactInfoFields,
  setContactErrorfromContactInfo,
  setGuests,
  // eslint-disable-next-line prettier/prettier
  setProspectObjectFromContactInfo
} from '../../features/offerSearch/offerSearchSlice';
import { RootState } from '../../redux/rootReducer';
import { States_US } from '../../util/States';
import { PIN } from '../../util/strings';
import { isEqual, validateFields } from '../../util/validation';
import withLocalization from '../hoc/withLocalization';
import './ContactInformation.scss';
import GuestInformation from './GuestInformation';

const ContactInformationForm: FC<any> = (props: any): ReactElement => {
  const dispatch = useDispatch();
  const { localize } = props;

  const offerDetails = useSelector((state: RootState) => state.offerDetails);
  const searchParameter = offerDetails.searchParameter;
  const prospect = offerDetails.prospect;
  const prospectStateName = prospect && prospect.stateProvince ? prospect.stateProvince : '';
  const modePin = searchParameter.mode === PIN ? true : false;
  const maxGuests = offerDetails.selectedRoomType?.sleepCapacity;
  const guestInfo = offerDetails.guests;
  const numberofAdults = guestInfo ? guestInfo.adults : 1;
  const numberofChildren = guestInfo ? guestInfo.children : 0;
  const [numOfadults, setAdults] = useState(numberofAdults);
  const [numOfchildren, setChildren] = useState(numberofChildren);
  const [exceedCapacity, setExceedCapacity] = useState(false);
  const hasProspectState = prospect && prospect.stateProvince && prospect.stateProvince.length > 0;
  const stateName = hasProspectState
    ? prospectStateName.length > 2
      ? prospectStateName
      : States_US.filter((e) => e.code === prospectStateName)[0].name
    : '';
  const billingInfo = offerDetails.billingInfo;
  const contactError = offerDetails.contactError;
  const [prospectObject, setProspectObject] = useState({
    firstName: {
      fieldValue: prospect ? prospect.firstName : '',
      error: contactError ? contactError.firstName : '',
    },
    lastName: {
      fieldValue: prospect ? prospect.lastName : '',
      error: contactError ? contactError.lastName : '',
    },
    spouseFirstName: {
      fieldValue: prospect ? prospect.spouseFirstName : '',
      error: '',
    },
    spouseLastName: {
      fieldValue: prospect ? prospect.spouseLastName : '',
      error: '',
    },
    addressLine1: {
      fieldValue: prospect ? prospect.addressLine1 : '',
      error: contactError ? contactError.addressLine1 : '',
    },
    unitNo: {
      fieldValue: prospect ? prospect.unitNo : '',
      error: '',
    },
    city: {
      fieldValue: prospect ? prospect.city : '',
      error: contactError ? contactError.city : '',
    },
    postalCode: {
      fieldValue: prospect ? prospect.postalCode : '',
      error: contactError ? contactError.postalCode : '',
    },
    email: {
      fieldValue: prospect ? prospect.email : '',
      error: contactError ? contactError.email : '',
    },
    phone: {
      fieldValue: prospect ? prospect.phone : '',
      error: contactError ? contactError.phone : '',
    },
    stateProvince: prospectStateName,
  });
  let isValidErrorValue =
    !!prospectObject.firstName.error ||
    !!prospectObject.lastName.error ||
    !!prospectObject.spouseFirstName.error ||
    !!prospectObject.spouseLastName.error ||
    !!prospectObject.email.error ||
    !!prospectObject.postalCode.error ||
    !!prospectObject.addressLine1.error ||
    !!prospectObject.city.error ||
    !!prospectObject.phone.error;

  let isValidFieldValue =
    !!prospectObject.firstName.fieldValue &&
    !!prospectObject.lastName.fieldValue &&
    !!prospectObject.email.fieldValue &&
    !!prospectObject.postalCode.fieldValue &&
    !!prospectObject.addressLine1.fieldValue &&
    !!prospectObject.city.fieldValue &&
    !!prospectObject.phone.fieldValue;

  const handleOnChange = (target) => {
    const { id, value } = target;
    const errMsg = validateFields(id, value);
    if (errMsg) {
      setProspectObject({
        ...prospectObject,
        [id]: { ...prospectObject[id], error: errMsg, fieldValue: value },
      });
    } else {
      setProspectObject({
        ...prospectObject,
        [id]: { ...prospectObject[id], error: '', fieldValue: value },
      });
    }
  };
  const onSelectionChange = (adultnum, childnum) => {
    let sum = parseInt(childnum) + parseInt(adultnum);
    const checkValidGuests = maxGuests && sum <= maxGuests ? true : false;
    setAdults(adultnum);
    setChildren(childnum);

    if (!checkValidGuests) {
      setExceedCapacity(true);
      dispatch(setAllContactInfoFields(true));
    } else if (checkValidGuests && isValidFieldValue && !isValidErrorValue) {
      dispatch(setGuests({ adults: adultnum, children: childnum }));
      dispatch(setAllContactInfoFields(false));
      setExceedCapacity(false);
    } else if (checkValidGuests) {
      dispatch(setGuests({ adults: adultnum, children: childnum }));
      setExceedCapacity(false);
    }
  };
  const handleBlur = (target) => {
    const { id, value } = target;
    const errMsg = validateFields(id, value);
    let tempProspectObject: any = {};
    if (errMsg) {
      tempProspectObject = {
        ...prospectObject,
        [id]: { ...prospectObject[id], error: errMsg, fieldValue: value },
      };
      setProspectObject({
        ...prospectObject,
        [id]: { ...prospectObject[id], error: errMsg, fieldValue: value },
      });
    } else {
      tempProspectObject = {
        ...prospectObject,
        [id]: { ...prospectObject[id], error: '', fieldValue: value },
      };
      setProspectObject({
        ...prospectObject,
        [id]: { ...prospectObject[id], error: '', fieldValue: value },
      });
    }
    // dispatchInfoToState();
    dispatch(
      setProspectObjectFromContactInfo({
        firstName: tempProspectObject.firstName.fieldValue,
        lastName: tempProspectObject.lastName.fieldValue,
        spouseFirstName: tempProspectObject.spouseFirstName.fieldValue,
        spouseLastName: tempProspectObject.spouseLastName.fieldValue,
        email: tempProspectObject.email.fieldValue,
        phone: tempProspectObject.phone.fieldValue,
        stateProvince: tempProspectObject.stateProvince,
        addressLine1: tempProspectObject.addressLine1.fieldValue,
        unitNo: tempProspectObject.unitNo.fieldValue,
        city: tempProspectObject.city.fieldValue,
        postalCode: tempProspectObject.postalCode.fieldValue,
      }),
    );
    dispatch(
      setContactErrorfromContactInfo({
        firstName: tempProspectObject.firstName.error,
        lastName: tempProspectObject.lastName.error,
        email: tempProspectObject.email.error,
        phone: tempProspectObject.phone.error,
        addressLine1: tempProspectObject.addressLine1.error,
        city: tempProspectObject.city.error,
        postalCode: tempProspectObject.postalCode.error,
      }),
    );
    dispatch(setGuests({ adults: numOfadults, children: numOfchildren }));
    if (!isEqual(prospect, billingInfo, true)) {
      dispatch(resetBillingCheckBox());
    }
  };
  useEffect(() => {
    if (modePin) {
      dispatch(setAllContactInfoFields(false));
    } else {
      if (isValidFieldValue && !isValidErrorValue && !exceedCapacity) {
        dispatch(setAllContactInfoFields(false));
      } else {
        dispatch(setAllContactInfoFields(true));
      }
    }
    if (!isEqual(prospect, billingInfo, true)) {
      dispatch(resetBillingCheckBox());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prospectObject, guestInfo]);
  return (
    <>
      <div className="formWrapper">
        <form noValidate>
          <div className="form-group">
            <label htmlFor="firstName">
              {localize('preview-sales-engine.static-content.copy.contact-information-page.first-name')}
              {!modePin ? <span className="asterisk">*</span> : <></>}

              <input
                type="text"
                className="form-control"
                id="firstName"
                value={prospectObject.firstName.fieldValue || ''}
                disabled={modePin}
                onChange={(e) => handleOnChange(e.target)}
                onBlur={(e) => handleBlur(e.target)}
                maxLength={30}
                required
              />
              <div className="invalid-feedback-onchange">{localize(prospectObject.firstName.error)}</div>
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="lastName">
              {localize('preview-sales-engine.static-content.copy.contact-information-page.last-name')}
              {!modePin ? <span className="asterisk">*</span> : <></>}
              <input
                type="text"
                className="form-control"
                id="lastName"
                value={prospectObject.lastName.fieldValue || ''}
                disabled={modePin}
                onChange={(e) => handleOnChange(e.target)}
                onBlur={(e) => handleBlur(e.target)}
                maxLength={30}
                required
              />
              <div className="invalid-feedback-onchange">{localize(prospectObject.lastName.error)}</div>
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="spouseFirstName">
              {localize('preview-sales-engine.static-content.copy.Labels.labels#souse-partner-first-name')}
              <input
                type="text"
                className="form-control"
                id="spouseFirstName"
                value={prospectObject.spouseFirstName.fieldValue || ''}
                onChange={(e) => handleOnChange(e.target)}
                onBlur={(e) => handleBlur(e.target)}
                maxLength={30}
                required
              />
              <div className="invalid-feedback-onchange">{localize(prospectObject.spouseFirstName.error)}</div>
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="spouseLastName">
              {localize('preview-sales-engine.static-content.copy.Labels.labels#souse-partner-last-name')}
              <input
                type="text"
                className="form-control"
                id="spouseLastName"
                value={prospectObject.spouseLastName.fieldValue || ''}
                onChange={(e) => handleOnChange(e.target)}
                onBlur={(e) => handleBlur(e.target)}
                maxLength={30}
                required
              />
              <div className="invalid-feedback-onchange">{localize(prospectObject.spouseLastName.error)}</div>
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="addressLine1">
              {localize('preview-sales-engine.static-content.copy.contact-information-page.street-address')}
              {!modePin ? <span className="asterisk">*</span> : <></>}
              <input
                type="text"
                className="form-control"
                id="addressLine1"
                value={prospectObject.addressLine1.fieldValue || ''}
                disabled={modePin}
                onChange={(e) => handleOnChange(e.target)}
                onBlur={(e) => handleBlur(e.target)}
                maxLength={30}
              />
              <div className="invalid-feedback-onchange">{localize(prospectObject.addressLine1.error)}</div>
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="city">
              {localize('preview-sales-engine.static-content.copy.contact-information-page.city')}
              {!modePin ? <span className="asterisk">*</span> : <></>}
              <input
                type="text"
                className="form-control"
                id="city"
                value={prospectObject.city.fieldValue || ''}
                disabled={modePin}
                onChange={(e) => handleOnChange(e.target)}
                onBlur={(e) => handleBlur(e.target)}
                maxLength={30}
              />
              <div className="invalid-feedback-onchange">{localize(prospectObject.city.error)}</div>
            </label>
          </div>
          <div className="form-row">
            <div className="form-group col-md-6">
              <label htmlFor="State">
                {localize('preview-sales-engine.static-content.copy.contact-information-page.state')}
                <input
                  type="text"
                  className="form-control"
                  id="State"
                  placeholder={stateName}
                  maxLength={30}
                  defaultValue={stateName}
                  readOnly
                />
              </label>
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="postalCode">
                {localize('preview-sales-engine.static-content.copy.contact-information-page.zip-code')}
                {!modePin ? <span className="asterisk">*</span> : <></>}
                <input
                  type="text"
                  className="form-control"
                  id="postalCode"
                  value={prospectObject.postalCode.fieldValue || ''}
                  disabled={modePin}
                  onChange={(e) => handleOnChange(e.target)}
                  onBlur={(e) => handleBlur(e.target)}
                  maxLength={10}
                />
                <div className="invalid-feedback-onchange">{localize(prospectObject.postalCode.error)}</div>
              </label>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-6">
              <label htmlFor="email">
                {localize('preview-sales-engine.static-content.copy.contact-information-page.email')}
                {!modePin ? <span className="asterisk">*</span> : <></>}
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  value={prospectObject.email.fieldValue || ''}
                  disabled={modePin}
                  onChange={(e) => handleOnChange(e.target)}
                  onBlur={(e) => handleBlur(e.target)}
                  maxLength={50}
                  required
                />
                <div className="invalid-feedback-onchange">{localize(prospectObject.email.error)}</div>
              </label>
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="phone">
                {localize('preview-sales-engine.static-content.copy.contact-information-page.phone')}
                {!modePin ? <span className="asterisk">*</span> : <></>}
                <input
                  type="text"
                  className="form-control"
                  id="phone"
                  value={prospectObject.phone.fieldValue || ''}
                  disabled={modePin}
                  onChange={(e) => handleOnChange(e.target)}
                  onBlur={(e) => handleBlur(e.target)}
                  maxLength={10}
                  required
                />
                <div className="invalid-feedback-onchange">{localize(prospectObject.phone.error)}</div>
              </label>
            </div>
          </div>
          <div className="form-group">
            <GuestInformation
              maxGuests={maxGuests}
              adultNum={numOfadults}
              childNum={numOfchildren}
              onGuestSelectionChange={onSelectionChange}
            />
            {exceedCapacity ? (
              <div className="invalid-feedback-onchange guest-error">
                {localize(
                  'preview-sales-engine.static-content.copy.contact-information-page.number-of-guests#invalid',
                  maxGuests,
                )}
              </div>
            ) : (
              ''
            )}
          </div>
        </form>
      </div>
    </>
  );
};
export default withRouter(withLocalization(ContactInformationForm));
